import { Injectable } from '@angular/core';
import { ApolloLink, FetchResult, NextLink, Observable, Operation } from 'apollo-link';
import { AppStateService } from './../services/app-state.service';

@Injectable({
  providedIn: 'root'
})
export class AppStateLink extends ApolloLink {
  public link: ApolloLink;

  constructor(private appStateService: AppStateService) {
    super();
  }

  public request(operation: Operation, forward: NextLink): Observable<FetchResult> | null {
    return forward(operation).map(result => {
      // console.log(operation.operationName, result);
      if (result.data) {
        // this.workflowAssistantService.onOperationIntercepted(operation.operationName, a.data);
        this.appStateService.onOperationIntercepted(operation.operationName, result.data);
      }
      return result;
    });
  }
}
